import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import { useTheme } from 'contexts'
import { ChatStack } from 'navigators/ChatStack'
import { HomeStack } from 'navigators/HomeStack'
import { NotificationsStack } from 'navigators/NotificationsStack'
import { ProfileStack } from 'navigators/ProfileStack'
import React, { useMemo } from 'react'

import { useFeatureFlags } from 'hooks/useFeatureFlags'

import * as constants from 'utils/constants'

import { useFocusMode } from 'contexts/FocusModeContext'

import { CustomTabBar } from './subcomponents/CustomTabBar'
import { CustomTabBar as NewCustomTabBar } from './subcomponents/_v2/CustomTabBar'

import { UpspaceStack } from '../UpspaceStack'

export type MainTabsParamList = {
  [constants.links.HOME_STACK]: undefined
  [constants.links.NOTIFICATIONS_STACK]: undefined
  [constants.links.CHAT_STACK]: undefined
  [constants.links.PROFILE_STACK]: undefined
  [constants.links.GROUP_STACK]: undefined
}

const MainTab = createBottomTabNavigator<MainTabsParamList>()

export const MainTabs = () => {
  const theme = useTheme()
  const focusMode = useFocusMode()
  const isFocusMode = useMemo(() => focusMode.group !== undefined, [focusMode.group])

  const { isNewDesignFlagEnabled } = useFeatureFlags()

  const baseTabConfiguration = {
    tabBarActiveTintColor: theme.colors.v2primary,
    tabBarActiveBackgroundColor: theme.colors.v2primary,
  }

  const customTabBar = (props: any) => {
    return isNewDesignFlagEnabled ? <NewCustomTabBar {...props} /> : <CustomTabBar {...props} />
  }

  return (
    <MainTab.Navigator
      screenOptions={{
        lazy: true,
        headerShown: false,
      }}
      tabBar={customTabBar}
    >
      <MainTab.Screen
        name={constants.links.HOME_STACK}
        component={HomeStack}
        options={{
          headerShown: false,
          title: 'Home',
          ...baseTabConfiguration,
        }}
      />

      {isNewDesignFlagEnabled && (
        <MainTab.Screen
          name={constants.links.NOTIFICATIONS_STACK}
          component={NotificationsStack}
          options={{
            headerShown: false,
            title: 'Activity',
            ...baseTabConfiguration,
          }}
        />
      )}

      <MainTab.Screen
        name={constants.links.CHAT_STACK}
        component={ChatStack}
        options={{
          headerShown: false,
          title: 'Chat',
          ...baseTabConfiguration,
        }}
      />

      {!isNewDesignFlagEnabled && (
        <>
          {isFocusMode ? (
            <>
              <MainTab.Screen
                name={constants.links.GROUP_STACK}
                component={UpspaceStack}
                options={{
                  headerShown: false,
                  title: 'Profile',
                  ...baseTabConfiguration,
                }}
              />
              <MainTab.Screen
                name={constants.links.PROFILE_STACK}
                component={ProfileStack}
                options={{
                  headerShown: false,
                  title: 'You',
                  ...baseTabConfiguration,
                }}
              />
            </>
          ) : (
            <>
              <MainTab.Screen
                name={constants.links.PROFILE_STACK}
                component={ProfileStack}
                options={{
                  headerShown: false,
                  title: 'You',
                  ...baseTabConfiguration,
                }}
              />

              <MainTab.Screen
                name={constants.links.GROUP_STACK}
                component={UpspaceStack}
                options={{
                  headerShown: false,
                  title: 'Group',
                  ...baseTabConfiguration,
                }}
              />
            </>
          )}
        </>
      )}
    </MainTab.Navigator>
  )
}
